/**
 * @generated SignedSource<<dccc5e89402395074693a9e20bc6e409>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleListItemWeeklyRange_routineOccasion$data = {
  readonly deadlineAt: string | null;
  readonly startAt: string;
  readonly " $fragmentType": "TeamScheduleListItemWeeklyRange_routineOccasion";
};
export type TeamScheduleListItemWeeklyRange_routineOccasion$key = {
  readonly " $data"?: TeamScheduleListItemWeeklyRange_routineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleListItemWeeklyRange_routineOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleListItemWeeklyRange_routineOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deadlineAt",
      "storageKey": null
    }
  ],
  "type": "ScheduledOccasion",
  "abstractKey": "__isScheduledOccasion"
};

(node as any).hash = "896de2b3baa0c3276ccd62960b14aae9";

export default node;
